module.exports = __webpack_public_path__ + "img/img8.fca583a7.png";